import React, { useState } from "react";
import style from "css/telehealth.module.css";
import { Link } from "react-router-dom";
import Questions from "components/app/questions";

function Main() {
  const composeList = [
    {
      id: 1,
      title: "원격 진료",
      txt: "스마트 텔레헬스 시스템을 통해 환자는 집이나 원격지에서 의료진과 화상으로 진료 받을 수 있습니다.  시간과 장소에 구애받지 않고 편리하게 의료 서비스를 받을 수 있습니다.",
      link: "smart-space/telehealth/telehealth",
      img: "img/smartspace/telemainCompose1.png",
    },
    {
      id: 2,
      title: "원격 회진",
      txt: "의료진은 개인 집무실이나 진료실에서 입원환자와 직접 대면하지 않고도 영상회의를 통해 회진을 진행할 수 있으며, 의료진과 환자가 보호자에게 영상회의를 통해 환자의 근황과 컨디션을 실시간으로 전달할 수 있습니다.",
      link: "smart-space/telehealth/telerounding",
      img: "img/smartspace/telemainCompose2.png",
    },
    {
      id: 3,
      title: "원격 협진",
      txt: "복잡한 의료 케이스나 전문의 간의 협력이 필요한 상황에서 원격 협진 기능이 유용합니다. 진단의 정확성을 높이고, 최적의 치료 방안을 신속하게 마련할 수 있습니다.",
      link: "smart-space/telehealth/teleconsolution",
      img: "img/smartspace/telemainCompose3.png",
    },
    {
      id: 4,
      title: "의료 세미나 / 학술대회",
      txt: "세미나실이나 강의실 환경에 맞게 시스템을 구성할 수 있으며 의료진은 최신 의료 지식을 공유하고 전문성을 높일 수 있는 기회를 가질 수 있습니다.",
      link: "smart-space/telehealth/symposium",
      img: "img/smartspace/telemainCompose4.png",
    },
    {
      id: 5,
      title: "입원실 및 중환자실",
      txt: "환자와 의료진 & 가족(보호자)과 연결이 가능합니다. 면회가 불가한 중환자실이나 지리적 한계가 있는 보호자와 환자 간의 연결이 가능 해짐으로써 환자의 심리적 안정과 보호자와의 원활한 소통이 가능해집니다.",
      link: "smart-space/work/reception",
      img: "img/smartspace/telemainCompose5.png",
    },
    {
      id: 6,
      title: "고객 상담 시스템",
      txt: "병원 방문객이나 환자 및 보호자에게 효율적인 안내와 지원을 제공하기 위해 설계되었습니다. 이 시스템은 안내데스크 역할을 수행하여, 방문객이 병원내에서 필요한 정보를 신속하게 제공받을 수 있도록 돕습니다.",
      link: "smart-space/work/reception",
      img: "img/smartspace/telemainCompose6.png",
    },
  ];

  const [exNum, setExNum] = useState(1);
  const exList = [
    {
      id: 1,
      title: "온케어 시스템 장점",
      txt: "별도의 플랫폼에서 하던 진료·처방 기록을 앞으로는 병원 정보시스템에 다양한 기능의 화상 플랫폼을 내재화하여 진료 연속성을 보장합니다.",
    },
    {
      id: 2,
      title: "뛰어난 환자 접근성",
      txt: "별도의 플랫폼에서 하던 진료·처방 기록을 앞으로는 병원 정보시스템에 다양한 기능의 화상 플랫폼을 내재화하여 진료 연속성을 보장합니다.",
    },
    {
      id: 3,
      title: "서비스 구성도",
      txt: "별도의 플랫폼에서 하던 진료·처방 기록을 앞으로는 병원 정보시스템에 다양한 기능의 화상 플랫폼을 내재화하여 진료 연속성을 보장합니다.",
    },
    {
      id: 4,
      title: "보도 영상",
      txt: "별도의 플랫폼에서 하던 진료·처방 기록을 앞으로는 병원 정보시스템에 다양한 기능의 화상 플랫폼을 내재화하여 진료 연속성을 보장합니다.",
    },
  ];
  return (
    <div className={style.wrapper}>
      <div className={style.mainImg}>
        <div className={style.mainTxt}>
          <p>Smart Telehealth System</p>
          <p>미래지향적 최첨단</p>
          <p>스마트 텔레헬스 시스템</p>
        </div>

        <img
          alt=""
          src={
            `${process.env.REACT_APP_CLIENT_URL}` +
            "img/smartspace/workspacemain.png"
          }
        />
      </div>
      <div className={style.mainInfo}>
        <div className={style.mainInfoHeader}>
          <p>
            스마트 텔레헬스 시스템은 <br />
            최첨단
            <font> 원격 진료 </font>
            기술과 실시간
            <font> 비대면 진료</font>를 결합하여 새로운 의료 기준을 제시합니다.
          </p>
          <p>
            공간과 시간의 제약을 넘어 의료진과 환자가 실시간으로 소통하고 협력할
            수 있는 환경을 제공하며, 효율적인 진료와 협진을 지원하는 스마트 의료
            시스템을 구현합니다.
          </p>
        </div>
        <div className={style.mainInfoBody}>
          <div className={style.mainInfoBodyImg}>
            <img
              alt=""
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                "img/smartspace/telemain1.png"
              }
            />
          </div>
          <div className={style.mainInfoBodytxt}>
            <div className={style.mainInfoBodyWrap}>
              <p>Zoom 앱</p>
              <p>
                <font>신속하고 간편한 의료진 연결 :</font>
                <font>
                  의료진과 환자, 보호자가 안전하고 손쉽게 연결됩니다. 또한,
                  Zoom은 국제적으로 인증된 보안 기술을 통해 의료 데이터의
                  안전성을 보장합니다.
                </font>
              </p>
            </div>
            <div className={style.mainInfoBodyPlus}>
              <img
                alt=""
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/smartspace/telemainPlus.png"
                }
              />
            </div>
            <div className={style.mainInfoBodyWrap}>
              <p>Neat 스마트 화상회의 장비</p>
              <p>
                <font>선명한 화질과 몰입감 있는 회의 환경 :</font>
                <font>
                  Neat Board · Neat Bar · Neat Frame 등의 스마트 장비를 통해
                  고해상도 화질과 뛰어난 오디오 품질을 제공 합니다.
                </font>
              </p>
            </div>
            <div className={style.mainInfoBodyPlus2}>
              <img
                alt=""
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/smartspace/telemainPlus.png"
                }
              />
            </div>
            <div className={style.mainInfoBodyWrap}>
              <p>MediLink로 기존 시스템과의 연결</p>
              <p>
                <font>병원시스템과의 완벽한 통합 :</font>
                <font>
                  MediLink는 병원의 기존 정보 시스템과 통합되어 진료, 처방,
                  기록의 연속성을 유지합니다.
                </font>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className={style.mainComposeWrap}>
        <div className={style.mainCompose}>
          <div className={style.mainComposeTitle}>
            <p>스마트 텔레헬스 시스템</p>
            <p>
              <font>구성</font> 및 <font>공간</font>
            </p>
            <p>
              공간의 제약을 넘어 언제 어디서나 안전하고 효과적인 의료 서비스를
              경험할 수 있도록 지원합니다.
            </p>
          </div>

          <div className={style.mainComposeList}>
            {composeList.map((item) => (
              <div className={style.mainComposeCard}>
                <Link to={`${process.env.REACT_APP_CLIENT_URL + item.link}`}>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}` + item.img}
                  />
                  <div className={style.mainComposeTxt}>
                    <font>{item.title}</font>
                    <font>{item.txt}</font>
                    {item.id === 5 || item.id === 6 ? (
                      ""
                    ) : (
                      <p>
                        <font>More</font>
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/arrowRight.png"
                          }
                        />
                      </p>
                    )}
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={style.mainPlatform}>
        <div className={style.mainPlatformTitle}>
          <p>스마트 텔레헬스 시스템</p>
          <p>
            <font>플랫폼 </font>(소프트웨어)
          </p>
          <p>기업 환경에 맞춘, 특성에 맞춘 근무환경을 제안해 드립니다.</p>
        </div>
        <div className={style.mainPlatformBody}>
          <div className={style.mainPlatformCard}>
            <div>
              <p>
                <font>원격 진료 / 회진</font> 플랫폼
              </p>
              <p>
                고객의 기본 어플리케이션과 화상회의 플랫폼 Zoom의 API연동을 통해
                <br />
                진료 대기실 및 예약 / 화상 진료가 가능한 솔루션 입니다.
              </p>

              <p>
                <font>More</font>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/arrowRight.png"
                  }
                />
              </p>
            </div>
            <div>
              <img
                alt=""
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/smartspace/telemainPlatform1.png"
                }
              />
            </div>
          </div>
          <div className={style.mainPlatformCard}>
            <div>
              <p>
                <font>원격 협진 </font> 플랫폼
              </p>
              <p>
                Zoom의 다양한 기능을 API와 SDK를 활용하여 병원 환경에 최적화된
                시스템으로 내재화한 솔루션입니다.
                <br />이 플랫폼은 병원의 특정 요구에 맞춰 구성할 수 있으며,
                사용자에게 최적의 통합 의료 서비스 경험을 제공합니다.
              </p>

              <p>
                <font>More</font>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/arrowRight.png"
                  }
                />
              </p>
            </div>
            <div>
              <img
                alt=""
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/smartspace/telemainPlatform1.png"
                }
              />
            </div>
          </div>
        </div>
      </div>
      <div className={style.mainExWrap}>
        <div className={style.mainEx}>
          <div className={style.mainExTitle}>
            <p>구축사례</p>
            <p>
              <font>한림대학교의료원 </font> 비대면의료 시스템
            </p>
            <p>(溫)OnCare시스템 {exNum}</p>
          </div>
          <div className={style.mainExBody}>
            <div className={style.ClickList}>
              {exList.map((info) =>
                info.id === exNum ? (
                  <div className={style.ClickBtn_on + " cursor"}>
                    <div>
                      <p>
                        <font>0{info.id}</font>
                        <font>{info.title}</font>
                      </p>
                      <p>
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/telemainMinus.png"
                          }
                        />
                      </p>
                    </div>
                    <div>{info.txt}</div>
                  </div>
                ) : (
                  <div
                    className={style.ClickBtn_off + " cursor"}
                    onClick={() => setExNum(info.id)}
                  >
                    <div>
                      <p>
                        <font>0{info.id}</font>
                        <font> {info.title}</font>
                      </p>
                      <p>
                        {" "}
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/telemainPlus2.png"
                          }
                        />
                      </p>
                    </div>
                    <div>{info.txt}</div>
                  </div>
                )
              )}
            </div>
            <div className={style.mainExBodyImg}>
              <div className={`${style.mainExBodyImgSlide}`}>
                <img
                  alt=""
                  className={exNum === 1 ? style.sli1 : style.slioff1}
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/telemainEx1.png"
                  }
                />
                <img
                  alt=""
                  className={exNum === 2 ? style.sli2 : style.slioff2}
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/telemainEx1.png"
                  }
                />
                <img
                  alt=""
                  className={exNum === 3 ? style.sli3 : style.slioff3}
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/telemainEx1.png"
                  }
                />
                <img
                  alt=""
                  className={exNum === 4 ? style.sli4 : style.slioff4}
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/telemainEx1.png"
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={style.clients}>
        <div className={style.clientsHeader}>
          <p>Clients and Partners</p>
          <p>
            2012년부터 리브테크놀로지와 많은 기업/기관/학교들이 함께했습니다.
          </p>
        </div>
        <div className={style.clientsInfo}>
          <div>
            <p>
              <font>89</font>
              <font>+</font>
            </p>
            <p>사용 기관</p>
          </div>
          <div />
          <div>
            <p>
              <font>568,676</font>
              <font>+</font>
            </p>
            <p>연 사용 인원</p>
          </div>
        </div>
        <div>이미지</div>
        <div className={style.clientsMore}>
          <p>More view Clients</p>
          <img
            alt=""
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              "img/smartspace/arrowRight.png"
            }
          />
        </div>
      </div>
      <Questions />
    </div>
  );
}

export default Main;
